module.exports = __webpack_public_path__ + "img/9.03bb94e4.png";